import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule, NgxUiLoaderConfig } from 'ngx-ui-loader';
import { MaterialModule } from 'projects/lib/medcare-core-lib/src/lib/modules/material.module';
import { MomentDateAdapterModule } from 'projects/lib/medcare-core-lib/src/lib/modules/moment-date-adapter.module';
import { PushNotificationModule } from 'projects/lib/medcare-core-lib/src/lib/modules/push-notification/push-notification.module';
import { AlertDialogModule } from 'projects/lib/medcare-core-lib/src/lib/modules/shared/alert_message/alert-dialog/alert-dialog.module';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PatientAuditTrailsComponent } from './components/patient-audit-trails/patient-audit-trails.component';
import { ChangeProviderComponent } from './shared/change-provider/change-provider.component';
import { ViewDocumentComponent } from './shared/view-document/view-document.component';
import { KinDetailsDialogComponent } from './shared/kin-details-dialog/kin-details-dialog.component';
import { AccountDetailsDialogComponent } from './shared/account-details-dialog/account-details-dialog.component';
import { EmergencyRegistrationListComponent } from './components/emergency-registration-list/emergency-registration-list.component';
import { EmergencyRegistrationComponent } from './components/emergency-registration/emergency-registration.component';
import { AppointmentReasonreamrksDialogComponent } from './components/patient-appointment-list/appointment-reasonreamrks-dialog/appointment-reasonreamrks-dialog.component';
import { AppointmentRemarksDialogComponent } from './components/patient-appointment-list/appointment-remarks-dialog/appointment-remarks-dialog.component';
import { PatientAppointmentListComponent } from './components/patient-appointment-list/patient-appointment-list.component';
import { AppointmentDetailsComponent } from './components/patient-appointment/appointment-details/appointment-details.component';
import { AppointmentQuickSearchComponent } from './components/patient-appointment/appointment-quick-search/appointment-quick-search.component';
import { ConfirmRemarksComponent } from './components/patient-appointment/confirm-remarks/confirm-remarks.component';
import { PatientAppointmentComponent, DialogAddAppointmentPatient } from './components/patient-appointment/patient-appointment.component';
import { PatientBlockAddComponent } from './components/patient-blocking/patient-block-add/patient-block-add.component';
import { PatientBlockDialog, PatientHistoryDialog, PatientBlockingComponent } from './components/patient-blocking/patient-blocking.component';
import { PatientEncounterListComponent } from './components/patient-encounter-list/patient-encounter-list.component';
import { PatientMergeListComponent } from './components/patient-merge-list/patient-merge-list.component';
import { PatientMergeComponent } from './components/patient-merge/patient-merge.component';
import { PatientNotesDialogComponent } from './components/patient-notes-dialog/patient-notes-dialog.component';
import { PatientRescheduleListComponent } from './components/patient-reschedule-list/patient-reschedule-list.component';
import { SamplePatientRegistrationComponent } from './components/sample-patient-registration/sample-patient-registration.component';
import { CameraDialogComponent } from './shared/camera-dialog/camera-dialog.component';
import { CancelVisitComponent } from './shared/cancel-visit/cancel-visit.component';
import { ConfirmCheckoutComponent } from './shared/confirm-checkout/confirm-checkout.component';
import { DocumentuploadComponent } from './shared/documentupload/documentupload.component';
import { EncounterCancelDialog } from './shared/encountercanceldialog/encountercanceldialog';
import { OrderstatusComponent } from './shared/orderstatus/orderstatus.component';
import { PhysicalLocationDialogComponent } from './shared/physical-location-dialog/physical-location-dialog.component';
import { RegsuccessDialogComponent } from './shared/regsuccess-dialog/regsuccess-dialog.component';
import { UpdatestatusComponent } from './shared/updatestatus/updatestatus.component';
import { UploadfileComponent } from './shared/uploadfile/uploadfile.component';
import { BlockService } from './services/Sblock.service';
import { DayService, WeekService, WorkWeekService, MonthService, YearService, AgendaService, TimelineViewsService, TimelineMonthService, TimelineYearService, PrintService, ExcelExportService, ICalendarExportService, RecurrenceEditorAllModule, ScheduleAllModule } from '@syncfusion/ej2-angular-schedule';
import { AppointmentService } from './services/Sappointment.service';
import { GeneralUrlService } from './services/SgeneralUrl.service';
import { MasterUrlService } from './services/SmasterUrl.service';
import { MergePatientService } from './services/Smerge-patient.service';
import { PatientRegistrationService } from './services/Spatient-registration.service';
import { patientGetDataservice } from './services/SpatientGetData.service';
import { SearchHeaderService } from './services/SsearchHeader.service';
import { CdkTableModule } from '@angular/cdk/table';
import { CheckBoxAllModule, ButtonAllModule, SwitchAllModule } from '@syncfusion/ej2-angular-buttons';
import { DatePickerAllModule, TimePickerAllModule, DateTimePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { DiagramModule } from '@syncfusion/ej2-angular-diagrams';
import { DropDownListAllModule, MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NumericTextBoxAllModule, TextBoxAllModule, MaskedTextBoxModule, UploaderAllModule } from '@syncfusion/ej2-angular-inputs';
import { ToolbarAllModule, ContextMenuAllModule, TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { DropDownButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { ApplicationPipeModule } from 'projects/lib/medcare-core-lib/src/lib/application-pipes/applicationpipes.module';
import { PatientSearchModule } from 'projects/lib/medcare-core-lib/src/lib/core/patient-search/patient-search.module';
import { SharedModule } from 'projects/lib/medcare-core-lib/src/lib/modules/shared/shared.module';
import { WebcamModule } from 'ngx-webcam';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { environment } from 'projects/lib/medcare-core-lib/environments/environment';
import { MedcareCoreUiModule } from 'projects/lib/medcare-core-lib/src/lib/medcare-core-ui.module';
import { AppComponent } from 'projects/lib/medcare-core-lib/src/lib/core/app-base/app.component';
import { SidebarModule } from 'ngx-angular-sidebar';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AddWaitingListDialogComponent } from './shared/add-waiting-list-dialog/add-waiting-list-dialog.component';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from 'projects/lib/medcare-core-lib/src/lib/services/custom-date-adapter';
import { CustomDateRangeAdapter } from 'projects/lib/medcare-core-lib/src/lib/services/custom-daterange-adapter';
import { DateRange } from '@angular/material/datepicker';
import { AuditTrailsComponent } from './components/audit-trails/audit-trails.component';
import { RecurringAppointmentsComponent } from './components/patient-appointment/recurring-appointments/recurring-appointments.component';
import { CalendarModule, DateAdapter as CalendarDateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { GridModule, PagerModule } from '@syncfusion/ej2-angular-grids';
import { AppoinmentPatientHistoryDialogComponentComponent } from './components/patient-appointment-list/appointment-patient-history/appoinment-patient-history-dialog-component/appoinment-patient-history-dialog-component.component';
import { SameDayAppointmentDialogComponent } from './shared/same-day-appointment-check-dailog/same-day-appointment-dialog/same-day-appointment-dialog.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#37ac94", 
  bgsOpacity: 0.5,
  bgsPosition: "center-center",
  bgsSize: 100,
  bgsType: "ball-spin-clockwise", 
  blur: 5,
  fgsColor: "#37ac94", 
  fgsPosition: "center-center",
  fgsSize: 80, 
  fgsType: "ball-spin-clockwise", 
  gap: 10,
  logoPosition: "center-center",
  logoSize: 50,
  logoUrl: "",
  masterLoaderId: "master",
  overlayBorderRadius: "0",
  overlayColor: "rgba(255,255,255,0.29)",
  hasProgressBar: false, 
  text: "",
  textColor: "#FFFFFF",
  textPosition: "center-center",
};

@NgModule({
  declarations: [
    PatientBlockDialog,
    PatientHistoryDialog,
    PatientBlockingComponent,
    PatientBlockAddComponent,
    //PatientRegistrationComponent,
    PatientEncounterListComponent,
    PatientAppointmentListComponent,
    PatientAppointmentComponent,
    AppointmentDetailsComponent,
    ConfirmRemarksComponent,
    //UnsavedFormDilogComponent,
    AppointmentRemarksDialogComponent,
    SamplePatientRegistrationComponent,
    CameraDialogComponent,
    RegsuccessDialogComponent,
    DocumentuploadComponent,
    AppointmentReasonreamrksDialogComponent,
    UploadfileComponent,
    OrderstatusComponent,
    DialogAddAppointmentPatient,
    EncounterCancelDialog,
    PatientMergeComponent,
    PatientMergeListComponent,
    PatientRescheduleListComponent,
    PatientNotesDialogComponent,
    //PatientAppointmentDialogComponent,
    AppointmentQuickSearchComponent,
    ConfirmCheckoutComponent,
    EmergencyRegistrationComponent,
    EmergencyRegistrationListComponent,
    CancelVisitComponent, 
    UpdatestatusComponent,
    PhysicalLocationDialogComponent,
    AccountDetailsDialogComponent,
    KinDetailsDialogComponent,
    ViewDocumentComponent,
    ChangeProviderComponent,
    PatientAuditTrailsComponent,
    AddWaitingListDialogComponent,
    AuditTrailsComponent,
    RecurringAppointmentsComponent,
    AppoinmentPatientHistoryDialogComponentComponent,
    SameDayAppointmentDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MedcareCoreUiModule.forRoot(environment),
    MaterialModule,
    PushNotificationModule,
    NgbModule,
    NgxMatSelectSearchModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    MomentDateAdapterModule,
    SidebarModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    NgxUiLoaderHttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    AlertDialogModule,
    NgxScannerQrcodeModule,
    CdkTableModule,
    // WebCamModule,
    WebcamModule,
    ApplicationPipeModule,
    PatientSearchModule,
    DragDropModule,
    SharedModule,
    ScheduleAllModule, 
    RecurrenceEditorAllModule,   
    NumericTextBoxAllModule, 
    TextBoxAllModule, 
    DatePickerAllModule, 
    TimePickerAllModule, 
    DateTimePickerAllModule, 
    CheckBoxAllModule,   
    ToolbarAllModule, 
    DropDownListAllModule, 
    ContextMenuAllModule, 
    MaskedTextBoxModule, 
    UploaderAllModule, 
    MultiSelectAllModule,   
    TreeViewModule, 
    ButtonAllModule, 
    DropDownButtonAllModule, 
    SwitchAllModule,
    DiagramModule,
    CalendarModule.forRoot({
      provide: CalendarDateAdapter,
      useFactory: adapterFactory,
    }),
    GridModule, PagerModule,
  ],
  // entryComponents: [
  //   PatientBlockDialog,
  //   PatientHistoryDialog,
  //   PatientBlockAddComponent,
  //   AppointmentDetailsComponent,
  //   ConfirmRemarksComponent,
  //   //UnsavedFormDilogComponent,
  //   AppointmentRemarksDialogComponent,
  //   AppointmentReasonreamrksDialogComponent,
  //   TranslateModule,
  //   DialogAddAppointmentPatient,
  //   PatientNotesDialogComponent,
  //   AddSponsorDialogComponent,
  //  // PatientAppointmentDialogComponent,
  //   AppointmentQuickSearchComponent,
  //   ViewDocumentComponent
  // ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppBaseService,
      multi: true,
    },
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: "0ms" } },
    BlockService, 
    AppointmentService, 
    PatientRegistrationService, 
    MasterUrlService, 
    SearchHeaderService, 
    GeneralUrlService,
    patientGetDataservice,
    MergePatientService,
    DayService, 
    WeekService, 
    WorkWeekService, 
    MonthService, YearService, AgendaService,
    TimelineViewsService, TimelineMonthService, TimelineYearService, PrintService, ExcelExportService, ICalendarExportService,
    // { provide: MAT_DATE_LOCALE, useValue: 'en' }, // Set Thai locale
    { provide: DateAdapter, useClass: CustomDateAdapter }, // Use the custom adapter
    { provide: DateRange, useClass: CustomDateRangeAdapter }
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule { }
